import React from "react";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Clickable } from "..";

interface SideNavLinkProps {
  to?: string;
  data?: any;
  icon?: IconProp;
  children?: React.ReactNode;
  targetBlank?: boolean;
}

export default function SideNavLink({
  to,
  data,
  icon,
  children,
  targetBlank,
}: SideNavLinkProps) {
  return (
    <Clickable
      className="h-app-side-nav-link"
      to={to}
      data={data}
      isNavLink
      targetBlank={targetBlank}
    >
      {icon && <FontAwesomeIcon icon={icon} />}
      {children}
    </Clickable>
  );
}
